export const getUrlParameter = (name) => new URLSearchParams(window.location.search).get(name) || '';

export const stripUrlParams = (...names) => {
  const url = new URL(window.location);
  names.forEach((n) => url.searchParams.delete(n));
  window.history.replaceState({}, document.title, url);
};
